import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
  GET_CONFIG_SYS_DAO_HO,
  SHOW_FORM_DAO_HO,
  POST_DAO_HO,
} from 'actions/TraGop/DaoHo/actionTypes';
import {
  postDaoHoFailure,
  postDaoHoSuccess,
  getConfigSysDaoHo as a_getConfigSysDaoHo,
  setConfig,
  showFormDaoHo as a_showFormDaoHo,
} from 'actions/TraGop/DaoHo';
import { pushNotification } from 'utils/notifications';
import CauHinhApi from 'service/cauHinhApi';
import DaoHoApi from 'service/traGopApi';
import { getListTraGop } from 'actions/TraGop';
import { getListPhiKhac } from 'actions/PhiKhac';

function* showFormDaoHo(action) {
  try {
    yield put(a_getConfigSysDaoHo());
    yield put(getListPhiKhac({ type: 2 }));
  } catch (error) {}
}

function* getConfigSysDaoHo(action) {
  try {
    const response = yield call(
      CauHinhApi.getConfigSys_TraGop,
      action.dataSearch
    );
    if (response.ok && response.data) {
      console.log('getConfigSysDaoHo');
      console.log(response.data);

      yield put(setConfig(response.data));
    }
  } catch (error) {
    console.log(error);
  }
}
function* postDaoHo(action) {
  try {
    const response = yield call(DaoHoApi.daoHo, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        yield put(postDaoHoFailure(response.data));
        pushNotification(response.data.Message, 'error', 'TOP_CENTER', 2000);
      } else {
        yield put(postDaoHoSuccess(response.data));
        yield put(a_showFormDaoHo(response.data));
        const state = yield select();
        let { dataSearch } = state.tragop;
        yield put(getListTraGop(dataSearch));
        pushNotification(response.data.Message, 'success', 'TOP_CENTER', 2000);
      }
    } else {
      pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
      yield put(postDaoHoFailure());
    }
  } catch (error) {
    pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
    yield put(postDaoHoFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_CONFIG_SYS_DAO_HO, getConfigSysDaoHo);
  yield takeLatest(SHOW_FORM_DAO_HO, showFormDaoHo);
  yield takeLatest(POST_DAO_HO, postDaoHo);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
